export const ACTBLUE_DONATIONS = "foothill-community-democrats-2";
export const DOMAIN = "foothillcommunitydemocrats.com";
export const EMAIL_SENDER = "noreply@foothillcomunitydemocrats.com";
export const FACEBOOK = "FoothillCommunityDemocrats";
export const FEC_ID = "C00417097";
export const FOOTER_CONTENT = "<p class=\"bold\">We're your friends and neighbors.  We're the Foothill Community Democrats!</p><p>Come join us as we work together to ensure equality and prosperity for all Americans and to restore our place as a beacon of true Democracy for the world.</p>";
export const PAC_NAME = "Foothill Community Democrats";
export const SMTP_SERVER = "localhost";
